var map = {
	"./8secondz.png": 9749,
	"./barclays - Copy.png": 7615,
	"./barclays.png": 7675,
	"./bartini.png": 7015,
	"./cabbagetreelandscape.png": 6250,
	"./cactus.png": 6074,
	"./cactuscan.png": 394,
	"./d-webbox.png": 9976,
	"./persistent.png": 2217,
	"./zopnik.png": 3568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1165;